import { useEffect, useState } from "react";

const Drugpolicy = () =>{

    return(<> 


{/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
     <img src="assets/img/banner/alcoholdrug.jpg" alt="MeriPustak-About"/>
       
    </div>

    {/* <!-- About Section Start --> */}
    <section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                <br/>
                <div className="row g-4 align-items-center bg-light-yellow">
                    <div className="col-lg-12">
                        <div className="about-content">
                           <h3 className="mt-3 mt-md-0 wow fadeInUp mb-2" data-wow-delay=".5s">Hygiene and Drug Policy</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                              MeriPustak team keeps work and packing area very clean while maintaining hygiene in the entire office.</p>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Our team adheres to the basic standards of hygiene as we help diminish the spread of disease-carrying bacteria and viruses. Each order and book which we process is CLEAN, BACTERIA and VIRUS FREE.</p>
							
							<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">MeriPustak has adopted this policy that is designed towards a positive approach to ensure our workplace is free from substance abuse of any kind such as alcohol, drugs, cigarettes, tobacco etc.</p>
							
                        </div>
                    </div>
                </div><br/>
				<div className="row g-4 align-items-center">
                    <div className="col-lg-12">
                        <div className="about-content">
                           <h3 className="mt-3 mt-md-0 wow fadeInUp mb-2" data-wow-delay=".5s">Principles of the policy:</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             MeriPustak strictly prohibits the use of alcohol, drugs and cigarettes and no team member shall be tolerated if found under the influence or possession of any of these in the library premises during working hours.</p>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">The company takes alcohol and drug abuse as a very serious matter as it affects the well-being of an individual and its surrounding and most importantly because it is counterproductive.</p>
							
                        </div>
                    </div>
                </div>
				<br/>
				
				<div className="row g-4 align-items-center bg-light-blue">
                    <div className="col-lg-6">
                        <div className="about-content">
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             No team member shall be allowed to attend work while under the influence of drugs or after consumption of alcohol. An exception can be made for drugs prescribed by medical practitioners for health reasons.</p>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">There shall be zero tolerance for the use of alcohol, drugs, and cigarettes. The work area is a no-smoking zone. Hence smokers are expected not to smoke while at work.</p>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Possession of drugs, alcohol, etc. meant for consumption or to sell or transfer to a team or another person is strictly prohibited.</p>
							
                        </div>
                    </div>
					<div className="col-lg-6">
                        <div className="about-content">
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             <b>The use of tobacco is also prohibited on all MeriPustak premises. Tobacco and smoking are prohibited within 20 feet of all entrances and exits to work premises.</b></p>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">The above applies to all the team members whether full-time or part-time. It also applies to all work-related functions such as meetings, conferences, parties, client functions or work lunches.</p>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Contravention of this policy is a gross misconduct and the company will take disciplinary action for breaching these policies which may lead to termination of employment or summary dismissal.</p>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">In case of possession of illegal drugs, tobacco products or alcohol, the same shall be reported to the police for criminal prosecution.</p>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">We expect all employees to co-operate on this policy and these rules are to be followed while you are in work premises and conducting work matters.</p>
							
                        </div>
                    </div>
                </div><br/><br/>
				<div className="row g-4 align-items-center bg-light-yellow">
                    <div className="col-lg-6">
                        <div className="about-content">
						<h3 className="mt-3 mt-md-0 wow fadeInUp mb-2" data-wow-delay=".5s">How it affects the workplace:</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             We are all aware of the grave consequences that arise due to the consumption of illegal substances, alcohol and the like. It affects a person's performance, judgment of work, co-ordination, hence leading to absenteeism, inefficiency and poor co-operation. It makes the team unreliable increasing the possibility of mishaps, problems and disturbances thereby endangering the safety of their co- workers. Use of such substances contributes to crores of rupees of lost productivity and thousands of work mishaps in the workplace every year.</p>
							
                        </div>
                    </div>
					<div className="col-lg-6">
                        <div className="about-content">
						<h3 className="mt-3 mt-md-0 wow fadeInUp mb-2" data-wow-delay=".5s">Why it is important</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                            Teams are considered the most important asset and it is crucial that a safe and healthy working environment is provided for our teams. This policy therefore basically aims towards the promotion of safety, good health and welfare of the entire workforce. It promotes a healthy lifestyle by encouraging the team to refrain from abusive substances for their overall well-being and development.</p>
							
                        </div>
                    </div>
                </div>
				
				
				
            </div>
        </div>
    </section>

      {/* <!-- Team Section Start --> */}
    <section className="team-section fix section-padding pt-0 margin-bottom-30">
        <div className="container">
            <div className="section-title text-center">
                <h2 className="mb-3 wow fadeInUp" data-wow-delay=".3s">Swachh Bharat Abhiyan in MeriPustak</h2>
            </div>
            <div className="array-button">
                <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                <button className="array-next"><i className="fal fa-arrow-right"></i></button>
            </div>
            <div className="swiper team-slider">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/1.jpg" alt="MeriPustak"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/2.jpg" alt="MeriPustak"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/3.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/4.jpg" alt="MeriPustak"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/5.jpg" alt="MeriPustak"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/6.jpg" alt="MeriPustak"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/7.jpg" alt="MeriPustak"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/8.jpg" alt="MeriPustak"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/9.jpg" alt="MeriPustak"/>
                                </div>
                            </div>
                        </div>
                    </div>
					
					
					
                </div>
            </div>
        </div>
    </section>

    </>);

}

export default Drugpolicy;